import React, { useEffect, useState } from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description"; // General file icon
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"; // PDF icon
import ArticleIcon from "@mui/icons-material/Article"; // DOC icon
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"; // Excel icon
import axios from "axios";
import { api } from "../../../utils/api";
import downloadicon from "../../../assets/images/downloadicon.svg";

const FileUpload = ({
  setDocumentUrl,
  filesList,
  title,
  sx,
  ml,
  mt,
  marginTop,
  isDisabled,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (filesList) {
      setUploadedFiles([filesList]); // Initialize with the filesList passed from the parent
    } else {
      setUploadedFiles([]); // Clear preview when parent clears documentUrl
    }
  }, [filesList]);

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    if (files.length === 0) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    for (let file of files) {
      if (!allowedTypes.includes(file.type)) {
        alert("Only .pdf, .doc, .docx, .xls, .xlsx files are allowed!");
        e.target.value = null;
        return;
      }
    }

    const formData = new FormData();
    for (let file of files) {
      formData.append("files", file);
    }

    setIsLoading(true);
    setErrorMessage("");
    try {
      const response = await axios.post(`${api}/cloud/upload-admin`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const files = response.data.urls || [];
      setUploadedFiles(files);

      // Send the URL of the first uploaded file back to the parent
      if (files.length > 0) {
        setDocumentUrl(files[0]); // Assuming you're taking the first file's URL
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      setErrorMessage("Failed to upload the files. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileDelete = () => {
    setUploadedFiles([]); // Clear the uploaded file
    setDocumentUrl(""); // Remove the file URL from the parent
  };

  const getFileIcon = (fileType) => {
    console.log("log files", fileType);
    if (fileType.includes("pdf")) {
      return <PictureAsPdfIcon sx={{ color: "red", fontSize: "20px" }} />;
    }
    if (fileType.includes("docx") || fileType.includes("doc")) {
      return <ArticleIcon sx={{ color: "blue", fontSize: "20px" }} />;
    }
    if (
      fileType.includes("xlsx") ||
      fileType.includes("xls") ||
      fileType.includes("sheet")
    ) {
      return <InsertDriveFileIcon sx={{ color: "green", fontSize: "20px" }} />;
    }
    return <DescriptionIcon sx={{ color: "gray", fontSize: "20px" }} />;
  };

  return (
    <Box sx={{ marginTop: "2px", ml: ml ? ml : "0rem" }}>
      {/* <Typography>Upload evidence</Typography> */}
      {uploadedFiles.length === 0 ? (
        <Box>
          <Typography sx={{ fontWeight: "bold" }}>
            {title ? title : ""}
          </Typography>
          <Button
            variant="outlined"
            component="label"
            sx={{
              marginTop: marginTop ? marginTop : "8px",
              padding: "6px 12px",
              borderRadius: "4px",
              fontWeight: "bold",
              color: "#1c486b",
              borderColor: "#1c486b",
              "&:hover": {
                borderColor: "#1c486b",
                backgroundColor: "rgba(28, 72, 107, 0.04)",
              },
            }}
          >
            <img
              src={downloadicon}
              alt="Upload Icon"
              style={{ width: "26px", height: "26px", marginRight: "8px" }}
            />
            {isLoading ? "Upload" : "Upload"}
            <input
              type="file"
              hidden
              accept=".doc,.docx,.pdf,.xls,.xlsx"
              onChange={handleFileUpload}
              disabled={isLoading}
            />
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            position: "relative",
            marginTop: mt ? mt : "16px",
            width: "14rem", // Adjust the width of the container
            height: "40px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "8px 20px 8px 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#f9f9f9",
            overflow: "hidden", // Prevent overflow
          }}
        >
          {/* Close Button */}
          {isDisabled && (
            <IconButton
              onClick={handleFileDelete}
              sx={{
                position: "absolute",
                // top: "4px",
                right: "4px",
                padding: "4px",
              }}
            >
              <CloseIcon sx={{ fontSize: "15px" }} />
            </IconButton>
          )}

          {/* File Information */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "12%",
              flex: 1,
            }}
          >
            {getFileIcon(uploadedFiles[0])}
            <Typography
              sx={{
                marginLeft: "8px",
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "12px",
                color: "#333",
              }}
            >
              {decodeURIComponent(uploadedFiles[0].split("/").pop())}
            </Typography>
          </Box>
        </Box>
      )}
      {errorMessage && (
        <Typography sx={{ color: "red" }}>{errorMessage}</Typography>
      )}
    </Box>
  );
};

export default FileUpload;
